import { render } from "./Col7.vue?vue&type=template&id=c30fdc7c"
import script from "./Col7.vue?vue&type=script&lang=js"
export * from "./Col7.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__